<div class="_import-clients-desktop-page">

	<page-header-component title="{{'CLIENTS_IMPORT.TITLE' | translate}}"></page-header-component>

    <div class="_explanation-container">
        <p innerHTML="{{'CLIENTS_IMPORT.EXPLANATION' | translate}}"></p>
    </div>

    <div class="_import-container">

        <div class="_left">

            <div class="_info">
                
                <div class="_step" *ngFor="let step of [1, 2, 3, 4]">
                    <div class="_step-number" [ngClass]="{'_active': step === activeStep}">
                        <p>{{step}}</p>
                    </div>
                    <div class="_step-info">
                        <p class="_step-info-title">
                            {{'CLIENTS_IMPORT.STEP_' + step + '.TITLE' | translate}}
                        </p>
                        <p class="_step-info-explanation">
                            {{'CLIENTS_IMPORT.STEP_' + step + '.SUBTITLE' | translate}}
                        </p>
                    </div>
                </div>
        
            </div>

            <div class="_disclaimer">
                <p [translate]="'CLIENTS_IMPORT.DISCLAIMER'"></p>
            </div>
        </div>

        <div class="_right" *ngIf="pageDataLoaded">

            <div class="_active-step-container">
                <div class="_step-number">
                    <p>{{activeStep}}</p>
                </div>
                <p class="_active-step-title">
                    {{'CLIENTS_IMPORT.STEP_' + activeStep + '.TITLE' | translate}}
                </p>
            </div>

            @if (!showError && !showPreview && !showUploadPending && !showSuccess) {
                <div class="_upload-container">
                    <span (click)="downloadImportTemplate()" class="_download-template-link">{{ 'CLIENTS_IMPORT.DOWNLOAD' | translate}}</span>
                    <input #fileInput name="file" id="file" type="file" class="file-input" accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' (change)="addExcelToForm($any($event))" label="SELECTEREN">
                </div>    
                <button [disabled]="!showUploadButton" class="_button _save-button" [translate]="'CLIENTS_IMPORT.UPLOAD'" (click)="startExcelValidationJob()"></button>
            } @else if (showUploadPending) {
                <div class="_pending-validation-container">
                    <div class="_loading-container">
                        <ion-spinner name="circles"></ion-spinner>
                        <p [translate]="'CLIENTS_IMPORT.LOADING'"></p>
                    </div>
                </div>
            } @else if (showPreview) {
                <div class="_found-clients-container">

                    <p class="_found-clients-title">{{'CLIENTS_IMPORT.IMPORTED_CLIENTS' | translate}}: {{clients?.length || 0}}</p>
                    <div class="_clients-container">
                        <div class="_client-container" *ngFor="let client of clients; let i = index" [ngClass]="{'_offset': i % 2 === 0}">
                            <div class="_client">
                                <p class="_client-info">{{client.firstname}} {{client.lastname}}</p>
                                <p class="_client-description">{{'CLIENT.ADDRESS' | translate}}: {{client.Address | address}}</p>
                                <p class="_client-description" *ngIf="client.birthDate">{{'CLIENT.EXTRA.BIRTH_DATE' | translate}}: {{client.birthDate | date:"dd/MM/yyyy"}}</p>
                            </div>
                            <div class="_client-actions">
                                <ion-icon src="./assets/icons/trash-outline.svg" (click)="removeClientFromImport(client)"></ion-icon>
                            </div>
                        </div>
                    </div>
    
                </div>

                <button class="_button _save-button" [translate]="'CLIENTS_IMPORT.IMPORT'" (click)="importClients()"></button>
            } @else if (showError) {
                <div class="_import-errors-container">

                    @if (importErrors) {
                        <p class="_errors-title">{{'CLIENTS_IMPORT.IMPORT_ERRORS' | translate}}</p>
                        <div class="_errors-container">
                            <div class="_error-container" *ngFor="let importError of importErrors; let i = index" [ngClass]="{'_offset': i % 2 === 0}">
                                <div class="_error">
                                    <p class="_error-row-info">{{'CLIENTS_IMPORT.IMPORT_ERROR_ROW' | translate}}: {{importError.excelRow}}</p>
                                    <ng-container *ngFor="let errors of importError.errors">
                                        <div class="_error-message-info-container">
                                            <ion-icon src="./assets/icons/absent-outline.svg"></ion-icon>
                                            <p>{{errors[0]}}</p>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    } @else if (apiError) {
                        <p class="_errors-title">{{'CLIENTS_IMPORT.API_ERROR' | translate}}</p>
                        <p class="_api-error">{{'CLIENTS_IMPORT.ERROR' | translate}}: {{apiError}}</p>
                    }
                </div>

                <button class="_button _retry-button" [translate]="'CLIENTS_IMPORT.RE_UPLOAD'" (click)="reUploadExcelFile()"></button>
            } @else if (showSuccess) {
                <div class="_import-success-container" >
                    <ion-icon src="./assets/icons/present-outline.svg"></ion-icon>
                    <p>{{'CLIENTS_IMPORT.SUCCESS' | translate}}</p>

                    <button class="_button _add-button" [translate]="'CLIENTS_IMPORT.GO_TO_CLIENTS'" (click)="goToClientsPage()"></button>
                </div>

                
            }

        </div>

    </div>
	
</div>

